// src/serviceWorkerRegistration.js

// CRA-optimized simple service worker registration
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is IPv6 localhost.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 is IPv4 localhost.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/
  )
);

export function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost; do extra checks.
        checkValidServiceWorker(swUrl);
      } else {
        // Register service worker
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl, { updateViaCache: "none" })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  // Check if service worker can be found
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and is a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister();
          window.location.reload();
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
